module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/osago@2x-4a5206e82700d2db9fa93ca9c5dce6cb.png.webp";